import { render, staticRenderFns } from "./NoteItem.vue?vue&type=template&id=782fb704&scoped=true&"
import script from "./NoteItem.vue?vue&type=script&lang=js&"
export * from "./NoteItem.vue?vue&type=script&lang=js&"
import style0 from "./NoteItem.vue?vue&type=style&index=0&id=782fb704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782fb704",
  null
  
)

export default component.exports